import MDEditor, { selectWord } from "@uiw/react-md-editor";
import { useState } from "react";
import { Button, Card } from "react-bootstrap";

export interface IMarkdownEditorProps {
    onChange: (newVal: string) => void;
    className?: string;
    noun?: string;
    value?: string;
}

const MarkdownEditor = (props: IMarkdownEditorProps) => {
    const [editing, setEditing] = useState(false);

    return (
        <Card data-color-mode="light">
            <Card.Body>
                {
                    editing &&
                    <>
                        <MDEditor
                            height={200}
                            value={props.value}
                            onChange={(val) => props.onChange(val ?? "")} />
                        <Button
                            style={{ width: "100%", height: "100%" }}
                            onClick={
                                () => setEditing(false)}>Close {props.noun && props.noun + " "}Editor</Button>
                    </>
                }
                {
                    !editing &&
                    <div onClick={() => { setEditing(true); }}>
                        <MDEditor.Markdown
                            source={props.value}
                            style={{
                                minHeight: "50px"
                            }} />
                    </div >
                }
            </Card.Body>
        </Card>
    );
}

export default MarkdownEditor;